import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted } from "vue";
import { useTrackEvent } from "shared/composables/tracking";
import Sidebar from "@/components/layout/Sidebar.vue";
import GalleryContent from "@/views/camera/components/GalleryContent.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Gallery',
  setup(__props) {

const trackEvent = useTrackEvent();

onMounted(() => {
  trackEvent("camera_gallery_view");
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Sidebar, null, {
    default: _withCtx(() => [
      _createVNode(GalleryContent)
    ]),
    _: 1
  }))
}
}

})